









import { Component, Vue, Prop } from "vue-property-decorator";

@Component
export default class CButton extends Vue {
  @Prop({ type: String, required: false, default: "fill" }) mode!:
    | "outline"
    | "fill";
  @Prop({ type: String, required: false, default: "m" }) size!: "s" | "m" | "l";
  @Prop({ type: String, required: false, default: "primary" }) color!:
    | "primary"
    | "danger";
  @Prop({ type: Boolean, required: false, default: false }) wide!: boolean;
  @Prop({ type: [Boolean, String], required: false, default: false })
  disabled!: boolean | "disabled";

  get classes() {
    const classes = [];

    // mode
    switch (this.mode) {
      case "outline":
        classes.push(`text-${this.color}-500`, "border", `border-${this.color}-500`);

        // disabledである場合、hoverに応答しない
        if (!this.buttonDisabled) {
          classes.push(`hover__bg-${this.color}-600`, "hover__text-white");
        }
        break;

      case "fill":
        classes.push(
          "text-white",
          "border",
          `border-${this.color}-500`,
          `bg-${this.color}-500`
        );

        // disabledである場合、hoverに応答しない
        if (!this.buttonDisabled) {
          classes.push(`hover__bg-${this.color}-600`);
        }
        break;
    }

    // size
    switch (this.size) {
      case "s":
        // TODO: tailwind v1影響確認
        //classes.push("text-s", "py-2", "px-3");
        classes.push("text-s", "px-3");
        break;
      case "m":
        classes.push("py-2", "px-6");
        break;

      case "l":
        classes.push("py-6", "px-8", "text-base");
        break;
    }

    // wide
    if (this.wide) {
      classes.push("w-full");
    }

    return classes;
  }

  get buttonDisabled(): boolean {
    return this.disabled === "disabled" || this.disabled;
  }
}
